module.exports = __webpack_public_path__ + "f5b7de7f1af89c55c66a8d9179ca18d7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-10.png
// module id = 2274
// module chunks = 0